import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../models/error.model';
import { IMainApiService } from '../../../services/api.service';
import { IApiService } from '../../../services/api.service.base';

interface IAddUserToWorkspaceRequest {
  workspaceId: string;
  userEmail: string;
  role: string;
}

interface IChangeMemberRoleRequest {
  workspaceId: string;
  userEmail: string;
  role: string;
}

interface IRemoveUserFromWorkspaceRequest {
  workspaceId: string;
  userEmail: string;
}

export interface ITeamApiService {
  addUserToWorkspaceAsync(request: IAddUserToWorkspaceRequest): Promise<void | ACDLError>;
  changeUserRoleAsync(request: IChangeMemberRoleRequest): Promise<void | ACDLError>;
  removeUserFromWorkspaceAsync(request: IRemoveUserFromWorkspaceRequest): Promise<void | ACDLError>;
}

export namespace ITeamApiService {
  export const $: interfaces.ServiceIdentifier<ITeamApiService> = Symbol('TEAM_API_SERVICE_TYPE');
}

@injectable()
export class TeamApiService implements ITeamApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async addUserToWorkspaceAsync(request: IAddUserToWorkspaceRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Workspace/addUser', request);
  }

  async changeUserRoleAsync(request: IChangeMemberRoleRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Workspace/changeUserRole', request);
  }

  async removeUserFromWorkspaceAsync(request: IRemoveUserFromWorkspaceRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Workspace/removeUser', request);
  }
}
